import useApiClient from './api-client'
import type { PromoProductPromoInfo, FpromoRecommendedResponse, FpromoListData, FpromoCodeData, FpromoRecommendedTagsResponse } from '@/types/api'
import type { GetProductPromosReqParams } from '@/types/product'

export const getProductPromos = async (pid: string | number, params: GetProductPromosReqParams) => {
  const api = useApiClient<{ list: PromoProductPromoInfo[] }>()
  const result = await api(`/promo/product/${pid}`, { query: params })

  return result
}

export const getProductRecommendedPromo = async (pid: string | number, params: GetProductPromosReqParams) => {
  const api = useApiClient<FpromoRecommendedResponse>()
  const result = await api(`/promo/product/${pid}/recommended-promo`, { query: params })

  return result
}

export const getProductPromoTags = async (pid: string | number) => {
  const api = useApiClient<FpromoRecommendedTagsResponse>()
  const result = await api(`/promo/product/${pid}/recommended-promo-tags`)

  return result
}

export const getPromoCodes = async () => {
  const api = useApiClient<FpromoListData>()
  const result = await api('/promo')

  return result
}

export const receivePromoCode = async (params: { promo_code: string }) => {
  const api = useApiClient<FpromoCodeData>()
  const result = await api('/promo', {
    method: 'POST',
    body: params,
  })

  return result
}
